import {
    ApplicationInsights,
    IEventTelemetry,
    IExceptionTelemetry,
    ITraceTelemetry
} from '@microsoft/applicationinsights-web';

export class AppInsights {
    static instance: ApplicationInsights;

    static init(code: string) {
        if (!code) {
            return;
        }
        AppInsights.instance = new ApplicationInsights({
            config: {
                connectionString: code
            }
        });
        AppInsights.instance.loadAppInsights();
    }

    static trackException(exception: IExceptionTelemetry, props?: { [key: string]: any }) {
        if (!AppInsights.instance) {
            return;
        }
        const properties = { userId: AppInsights.getUserId(), ...props };
        AppInsights.instance.trackException(exception, properties);
    }

    static trackEvent(warning: IEventTelemetry, props?: { [key: string]: any }) {
        if (!AppInsights.instance) {
            return;
        }
        const properties = { userId: AppInsights.getUserId(), ...props };
        AppInsights.instance.trackEvent(warning, properties);
    }

    static trackTrace(trace: ITraceTelemetry, props?: { [key: string]: any }) {
        if (!AppInsights.instance) {
            return;
        }
        const properties = { userId: AppInsights.getUserId(), ...props };
        AppInsights.instance.trackTrace({ message: trace.message, properties });
    }

    static getUserId() {
        return AppInsights.instance?.context?.user?.id;
    }
}
